import React, { useEffect, useContext, useRef } from 'react';
import { UserContext } from '../app/app';
import Gift from 'gift/gift';
import dragula from 'react-dragula';
import { updateData } from '../firebase';
import { sortBy } from 'lodash-es';

import 'react-dragula/dist/dragula.css';
import './list.scss';

const List = ({ email, gifts, uuid, userId, child }) => {
  const { currentUser } = useContext(UserContext);
  const containerRef = useRef(null);
  let drake;

  useEffect(() => {
    initializeDrag();
  });

  const initializeDrag = () => {
    if (email !== currentUser.email) {
      if (drake) {
        drake.destroy();
      }
    } else {
      drake = dragula([containerRef.current]);

      drake.on('drag', (el, target) => {
        target.childNodes.forEach((gift) => gift.classList.add('moving'));
      });

      drake.on('drop', (el, target, source, sibling) => {
        target.childNodes.forEach((gift, i) => {
          const uuid = gift.getAttribute('data-uuid');
          gifts[uuid].order = i;

          gift.classList.remove('moving');
        });

        updateData(`/users/${uuid}/gifts`, gifts);
      });

      drake.on('cancel', (el, target, source, sibling) => {
        target.childNodes.forEach((gift, i) => {
          gift.classList.remove('moving');
        });
      });
    }
  };

  const renderGifts = () => {
    if (!gifts) return null;

    let ordered = sortBy(gifts, ['order']);

    return ordered.map((gift) => {
      return (
        <Gift
          email={email}
          key={gift.uuid}
          uuid={uuid}
          userId={userId}
          child={child}
          gift={gift}
        />
      );
    });
  };

  return (
    <ol className="list" ref={containerRef}>
      {renderGifts()}
    </ol>
  );
};

export default List;
